import { Component } from '@angular/core';

@Component({
  selector: 'app-user-add-icon',
  templateUrl: './user-add-icon.component.html',
  styleUrl: './user-add-icon.component.scss',
})
export class UserAddIconComponent {}
